import { Injectable } from '@angular/core';
import { AlertifyService } from './alertify.service';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private alertify: AlertifyService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

  handleCertificateError(error: any): void {

    switch (true) {
      case error.status === 403:
        this.translate.get(["ALERTIFY.COURSE_NOT_COMPLETED", "BOOTSTRAP.MODAL.ERROR"]).subscribe((text: string) => {
          this.alertify.error(text)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: text['ALERTIFY.COURSE_NOT_COMPLETED'],
            modal_color_variant: "danger"
          })
        });
        break
      case error.status === 404:
        this.translate.get("ALERTIFY.404_CERTIFICATE").subscribe((text: string) => {
          this.alertify.error(text)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: text['ALERTIFY.404_CERTIFICATE'],
            modal_color_variant: "danger"
          })
        });
        break
      case error.status === 500:
        this.translate.get("ALERTIFY.500_CERTIFICATE").subscribe((text: string) => {
          this.alertify.error(text)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: text['ALERTIFY.500_CERTIFICATE'],
            modal_color_variant: "danger"
          })
        });
        break
      case error.name === "TimeoutError":
        this.translate.get("ALERTIFY.CERTIFICATE_TIMEOUT_ERROR").subscribe((text: string) => {
          this.alertify.error(text)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: text['ALERTIFY.CERTIFICATE_TIMEOUT_ERROR'],
            modal_color_variant: "danger"
          })
        });
        break
      default:
        this.translate.get("ALERTIFY.CERTIFICATE_DEFAULT_ERROR").subscribe((text: string) => {
          this.alertify.error(text)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: text['ALERTIFY.CERTIFICATE_DEFAULT_ERROR'],
            modal_color_variant: "danger"
          })
        });
    }

    console.error('Certificate error details:', error);
  }
}
